import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {DashboardModule} from './components/dashboard/dashboard.module';
import {SharedModule} from './shared/shared.module';
import {MailboxModule} from './components/mailbox/mailbox.module';
import {UsersModule} from './components/users/users.module';
import {SettingModule} from './components/setting/setting.module';
import {AuthModule} from './components/auth/auth.module';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ToastrModule} from 'ngx-toastr';
import {AuthGuardService} from './shared/service/authgaurd';
import {CommonDataService} from './shared/service/common-data.service';
import {SubjectServices} from './shared/service/subject.services';
import {CommonService} from './shared/service/common.service';
import {ServerHttpInterceptor} from './shared/service/http.interceptor';
import {PdfViewerModule} from 'ng2-pdf-viewer';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {CalendarModule, DateAdapter} from 'angular-calendar';
import {adapterFactory} from 'angular-calendar/date-adapters/date-fns';
import {DatePipe} from '@angular/common';
import {PipesModule} from './shared/pipes/pipes.module';
import {RoleGaurd} from './shared/service/roleGaurd';
import {APP_INITIALIZER} from '@angular/core';
import {EnvironmentService} from './environment.service';
import {DeactivateAnswering} from './shared/service/answering-deactivate';
import {StudentContentModule} from './components/student-content/student-content.module';
import {NgbModule, NgbTooltipConfig} from '@ng-bootstrap/ng-bootstrap';
import {ConnectionServiceModule} from 'ng-connection-service';
import { EnrollclasscodeComponent } from './components/enrollclasscode/enrollclasscode.component';
import {NgSelectModule} from '@ng-select/ng-select';
import { CustomMaterialModule } from './material.module';
import { PaymentComponent} from './components/payment/payment.component';
import { SocialLoginModule, SocialAuthServiceConfig } from '@abacritt/angularx-social-login';
import {GoogleLoginProvider } from '@abacritt/angularx-social-login';


@NgModule({
    declarations: [
        AppComponent,
        EnrollclasscodeComponent,
        PaymentComponent
    ],
    imports: [
        BrowserAnimationsModule,
        ToastrModule.forRoot(), // ToastrModule added
        BrowserModule.withServerTransition({appId: 'serverApp'}),
        HttpClientModule,
        AppRoutingModule,
        DashboardModule,
        SettingModule,
        StudentContentModule,
        AuthModule,
        SharedModule,
        MailboxModule,
        UsersModule,
        FormsModule,
        ReactiveFormsModule,
        PdfViewerModule,
        DragDropModule,
        PipesModule,
        CalendarModule.forRoot({
            provide: DateAdapter,
            useFactory: adapterFactory,
        }),
        NgbModule,
        ConnectionServiceModule,
        NgSelectModule,
        CustomMaterialModule,
        SocialLoginModule
    ],
    providers: [
        NgbTooltipConfig,
        AuthGuardService, RoleGaurd, CommonDataService, SubjectServices, CommonService, DatePipe, DeactivateAnswering,
        {provide: HTTP_INTERCEPTORS, useClass: ServerHttpInterceptor, multi: true},
        {
            provide: APP_INITIALIZER, useFactory: (envService: EnvironmentService) => () => envService.init(),
            deps: [EnvironmentService], multi: true
        },
        {
            provide: 'SocialAuthServiceConfig',
            useValue: {
                autoLogin: false,
                lang: 'en',
                providers: [
                    {
                        id: GoogleLoginProvider.PROVIDER_ID,
                        provider: new GoogleLoginProvider('116926485369-pu809s8khi5dr5seokmmggld3ff2822c.apps.googleusercontent.com'),
                    },
                ],

                onError: (err) => {
                    console.error(err);
                }
            } as SocialAuthServiceConfig,

        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
